import { useIntl } from 'react-intl';
import { ASSETS_CATEGORIES, LIABILITIES_CATEGORIES, OTHER_PL_CATEGORIES, VIEW_TYPES } from '../../../../core/types';
import { FORECAST_SUB_TAB_IDS } from '../navigation/const';

/**
 * Returns maps of i18n tab and category names for use in the UI
 */
export const useSubTabNameMaps = () => {
  const intl = useIntl();

  // Main tab names - these are used for the top tab navigation
  const tabNames: Record<string, string> = {
    [FORECAST_SUB_TAB_IDS.ASSETS]: intl.formatMessage({ id: 'predict.predictions.assets', defaultMessage: 'Assets' }),
    [FORECAST_SUB_TAB_IDS.COSTS]: intl.formatMessage({ id: 'predict.predictions.costs', defaultMessage: 'Costs' }),
    [FORECAST_SUB_TAB_IDS.EXPENSES]: intl.formatMessage({
      id: 'financial_fields.category.expenses',
      defaultMessage: 'Expenses'
    }),
    [FORECAST_SUB_TAB_IDS.LIABILITIES]: intl.formatMessage({
      id: 'predict.predictions.liabilities',
      defaultMessage: 'Liabilities'
    }),
    [FORECAST_SUB_TAB_IDS.OTHER_P_AND_L]: intl.formatMessage({
      id: 'predict.predictions.other_p_and_l',
      defaultMessage: 'Other P&L'
    }),
    [FORECAST_SUB_TAB_IDS.SALES]: intl.formatMessage({ id: 'financial_fields.category.sales', defaultMessage: 'Sales' })
  };

  // Category names - these are used for the category dropdown (top left cell) within each tab
  const categoryNames: Record<string, Record<string, string>> = {
    [FORECAST_SUB_TAB_IDS.ASSETS]: {
      [ASSETS_CATEGORIES.CURRENT_ASSETS]: intl.formatMessage({
        id: 'financial_fields.category.current_assets',
        defaultMessage: 'Current Assets'
      }),
      [ASSETS_CATEGORIES.FIXED_ASSETS]: intl.formatMessage({
        id: 'financial_fields.category.fixed_assets',
        defaultMessage: 'Fixed Assets'
      }),
      [ASSETS_CATEGORIES.NON_CURRENT_ASSETS]: intl.formatMessage({
        id: 'predict.non_current_assets',
        defaultMessage: 'Non-current Assets'
      })
    },
    [FORECAST_SUB_TAB_IDS.LIABILITIES]: {
      [LIABILITIES_CATEGORIES.CURRENT_LIABILITIES]: intl.formatMessage({
        id: 'financial_fields.category.current_liabilities',
        defaultMessage: 'Current Liabilities'
      }),
      [LIABILITIES_CATEGORIES.NON_CURRENT_LIABILITIES]: intl.formatMessage({
        id: 'financial_fields.category.non_current_liabilities',
        defaultMessage: 'Non Current Liabilities'
      })
    },
    [FORECAST_SUB_TAB_IDS.OTHER_P_AND_L]: {
      [OTHER_PL_CATEGORIES.OTHER_INCOME]: intl.formatMessage({
        id: 'financial_fields.category.other_income',
        defaultMessage: 'Other Income'
      }),
      [OTHER_PL_CATEGORIES.OTHER_EXPENSES]: intl.formatMessage({
        id: 'financial_fields.category.other_expenses',
        defaultMessage: 'Other Expenses'
      })
    }
  };

  // View type names - not sure where these are used?
  const viewNames: Record<string, string> = {
    [VIEW_TYPES.ACCRUALS_BS]: intl.formatMessage({
      id: 'predict.accruals_bs_view',
      defaultMessage: 'Accruals (BS) view'
    }),
    [VIEW_TYPES.ACCRUALS_PL]: intl.formatMessage({
      id: 'predict.accruals_pl_view',
      defaultMessage: 'Accruals (P&L) view'
    }),
    [VIEW_TYPES.CASH_FLOW]: intl.formatMessage({
      id: 'predict.cash_flow_view',
      defaultMessage: 'Cash flow view'
    })
  };

  return {
    tabNames,
    categoryNames,
    viewNames
  };
};
